export const AUTH_LABELS = {
  app: {
    name: 'NovaBank',
    logoMark: 'N',
  },
  hero: {
    titleLine1: 'Banking made',
    titleLine2: 'Simple. Secure. Digital.',
    featureSecureTitle: 'Secure Banking',
    featureSecureDescription: 'Protect your money using enterprise-grade security.',
    featureManageTitle: 'Manage Accounts',
    featureManageDescription: 'Access all your savings accounts anytime.',
    featureBankingTitle: '24×7 Banking',
    featureBankingDescription: 'Transfer money and perform banking whenever you need.',
    skylineAlt: 'NovaBank Skyline',
  },
  login: {
    title: 'Welcome Back',
    subtitle: 'Sign in to your NovaBank Internet Banking account securely.',
    mobileNumberLabel: 'Mobile Number',
    mobileNumberPlaceholder: 'Enter Mobile Number',
    mobileNumberRequired: 'Mobile Number is required',
    mobileNumberInvalid: 'Mobile number must be exactly 10 digits',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter Password',
    passwordRequired: 'Password is required',
    submitButton: 'Secure Login',
    footerText: "Don't have a NovaBank account?",
    footerLink: 'Register',
  },
  otp: {
    title: 'Verify Your Account',
    subtitle: 'Enter the verification code sent to your registered contact.',
    emailLabel: 'Email',
    mobileLabel: 'Mobile',
    contactNotAvailable: 'Not available',
    deliveryMethodTitle: 'Select how to receive the OTP',
    otpSentSuccess: 'OTP sent successfully.',
    otpRequired: 'OTP is required',
    otpOnlyDigits: 'OTP must contain only digits',
    otpLengthInvalid: 'OTP must contain 6 digits',
    otpLabelEmail: 'Email OTP',
    otpLabelMobile: 'Mobile OTP',
    otpExpiresIn: 'OTP expires in',
    expired: 'Expired',
    verifyButton: 'Verify',
    lockedOutButton: 'Locked Out',
    lockedOutMessage:
      'Too many incorrect attempts. Please request a new OTP.',
    resendText: "Didn't receive the OTP?",
    resendButton: 'Resend OTP',
    resendButtonWithCountdown: (seconds: number) =>
      `Resend OTP (00:${seconds.toString().padStart(2, '0')})`,
    sendingOtp: 'Sending OTP...',
    authenticationRequiredError: 'authentication required',
    rateLimitError: 'please wait before requesting a new otp',
    loginSuccessToast: 'Login Successful',
    backToLogin: 'Back to',
    backToLoginLink: 'Login',
  },
  depositSlip: {
    downloadButton: 'Download Blank Deposit Slip',
    downloading: 'Downloading...',
    downloadSuccess: 'Download started.',
    downloadFailed: 'Unable to download deposit slip. Please try again.',
    sessionExpired: 'Your session has expired. Please log in again.',
    noAccount:
      'No active savings account found. Deposit slip download is not available.',
    invalidFormat: 'Invalid file format received. Expected PDF.',
  },
} as const;
